/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import React, { Fragment, useState } from 'react';
import Copy from '@jda/lui-common-icon-library-mui5/ui/Copy';
import CopyToClipboard from 'react-copy-to-clipboard';
import { Box, Typography, Tooltip } from '@mui/material';
import { useStyles } from './styles';
import { USER_SUBJECTID_DETAIL } from './constants';

interface IDisplayContentProps {
  contentText: string;
  content: string;
  testId: string;
  isNewUser: Boolean;
  handleCopyClick?: Function;
}

const DisplayContent: React.FC<IDisplayContentProps> = ({
  contentText,
  content,
  testId,
  isNewUser,
  handleCopyClick
}) => {
  const { classes } = useStyles();
  const [, setCopied] = useState(false);
  const handleClick = () => {
    setCopied(true);
    if (handleCopyClick) {
      handleCopyClick();
    }
  };
  return (
    <Fragment>
      <Typography data-testid={`${testId}-label`} gutterBottom variant="body1" fontWeight={500} >
        {contentText}
      </Typography>
      <Box className={isNewUser ? classes.newUserValueContainer : classes.valueContainer}>
        <Typography data-testid={`${testId}-value`} gutterBottom variant="body1" className={classes.content}>
          {isNewUser ? USER_SUBJECTID_DETAIL : content}
        </Typography>
        <Tooltip title="copy">
          <Box data-testid="toolTip-sign">
            <CopyToClipboard data-testid={`display-copy-to-clipboard-${testId}`} text={content} onCopy={handleClick}>
              <Copy id="display-content-id" className={`${classes.pointer} ${isNewUser ? classes.hide : ''}`} />
            </CopyToClipboard>
          </Box>
        </Tooltip>
      </Box>
    </Fragment>
  );
};

export default DisplayContent;
